const TRAINING_FALLBACK_URL = 'https://unacemcantera.pe/constructor/cursos-online';

/**
 * Opens the Capacitarme / training URL in a new tab.
 * Uses the constructorRedirectUrl from the login response when the user is
 * authenticated; falls back to the public UNACEM Cantera courses page otherwise.
 *
 * @param constructorRedirectUrl - Value returned by AuthService.constructorRedirectUrl()
 */
export const openTrainingUrl = (constructorRedirectUrl: string | null | undefined): void => {
  const url = constructorRedirectUrl ?? TRAINING_FALLBACK_URL;
  window.open(url, '_blank', 'noopener,noreferrer');
}
